import React, { useEffect, useState } from "react";
import {
  Search as SearchIcon,
  GridOn as ExcelIcon,
  ArrowBackIosNew,
  BlockOutlined,
} from "@mui/icons-material";
import MainLayout from "../../admin/MainLayout";
import {
  Box,
  Button,
  Chip,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserQuoteByID } from "../../../redux/slices/dashSlice";
import LoadingIndicator from "../../utils/LoadingIndicator";
import RoleSelect from "../../utils/RoleSelect";
import DateRangeFilter from "../../utils/DateRangeFilter";
import { fetchRegion, fetchState } from "../../../redux/slices/clientSlice";
import FilterBar2 from "../../admin/admin_dashboard/FilterBar2";
const FY_MONTH_ORDER = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];

const roleOptions = [
  { label: "IC", value: 2 },
  { label: "BSP", value: 3 },
  { label: "DSP", value: 4 },
  { label: "BD", value: 5 },
  { label: "Sales Enabler", value: 6 },
  { label: "Dealer", value: 7 },
  { label: "Studio", value: 8 },
];

const QuoteByUserId = () => {
  const dispatch = useDispatch();
  const { userQuoteById, totalCount, getStatus } = useSelector(
    (state) => state.dash
  );

  const { regionOpt, stateOpt } = useSelector((state) => state.adminOption);

  const { state } = useLocation();
  const month = state?.month;
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [roleId, setRoleId] = useState(state.role || []);
  const [fromDate, setFromDate] = useState(state.from || null);
  const [toDate, setToDate] = useState(state.to || null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedMonth, setSelectedMonth] = useState(
    Array.isArray(month) ? month : month ? [month] : FY_MONTH_ORDER
  );
  const [selectedYear, setSelectedYear] = useState(
    Array.isArray(state.year)
      ? state.year.map(String)
      : state.year
        ? [String(state.year)]
        : [String(new Date().getFullYear())]
  );
  const [selectedRegion, setSelectedRegion] = useState(state.selectedRegion || null);
  const [selectedState, setSelectedState] = useState(Array.isArray(state.selectedState) ? state.selectedState : state.selectedState ? [state.selectedState] : []);
  const [channelOpt, setChannelOpt] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);

  useEffect(() => {
    dispatch(
      fetchUserQuoteByID({
        userId: state.id,
        page: page + 1,
        rowsPerPage,
        search: searchTerm,
        role: roleId,
        from: fromDate,
        to: toDate,
        month: fromDate || toDate ? null : selectedMonth,
        year: fromDate || toDate ? null : selectedYear,
        selectedRegion: selectedRegion,
        selectedState: selectedState,
      })
    );
  }, [
    state,
    page,
    rowsPerPage,
    roleId,
    fromDate,
    toDate,
    searchTerm,
    selectedMonth,
    selectedYear,
    selectedRegion,
    selectedState,
  ]);

  const handleBackClick = () => navigate(-1);
  const handleDownloadExcel = () => { };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const downloadFile = async () => {
    {
      if (!userQuoteById || userQuoteById.length === 0) return;

      const dataToExport = userQuoteById.map((client, index) => ({
        "S.No.": index + 1,
        "Quotation ID": client.project_id,
        Client: client.client_name,
        Username: client.username,
        Role:
          client.role == 2
            ? "IC"
            : client.role == 3
              ? "BSP"
              : client.role == 4
                ? "DSP"
                : client.role == 5
                  ? "BD"
                  : client.role == 6
                    ? "Sales Enabler"
                    : client.role == 7
                      ? "Dealer"
                      : client.role == 8
                        ? "Studio"
                        : client.role,
        "Valid Upto": new Date(client.valid_date).toLocaleDateString("en-GB"),
        Stage: client.status,
        "Created At": new Date(client.created_at).toLocaleString("en-GB"),
        "Updated At": new Date(client.updated_at).toLocaleString("en-GB"),
      }));

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Clients");
      XLSX.writeFile(wb, "user_quote.xlsx");
    }
  };

  const MONTHS_LABELS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const months = FY_MONTH_ORDER.map((m) => ({
    value: m,
    label: MONTHS_LABELS[m - 1],
  }));

  const currentYear = new Date().getFullYear();
  const startYear = 2023;
  const yearCount = currentYear - startYear + 1;

  const years = Array.from({ length: yearCount }, (_, i) => {
    const year = currentYear - i;
    return {
      value: String(year),
      label: `${year}-${year + 1}`,
    };
  });

  const yearOptions = years.map((y) => ({ label: y.label, value: y.value }));

  // 2. Filter configurations array
  const filterConfigs = [
    {
      id: "role",
      label: "Role",
      options: roleOptions,
      selected: roleOptions.filter((s) => roleId.includes(s.value)),
    },
    {
      id: "region",
      label: "Region",
      options: regionOpt,
      selected: regionOpt.filter((s) => selectedRegion.includes(s.value)),
    },
    {
      id: "state",
      label: "State",
      options: stateOpt,
      selected: stateOpt.filter((s) => selectedState.includes(s.value)),
    },
    {
      id: "year",
      label: "Year (FY)",
      options: yearOptions,
      selected: yearOptions.filter((y) => selectedYear.includes(y.value)),
    },
  ];

  // 3. Unified Filter Change Callback
  const handleFilterChange = (filterId, nextSelected) => {
    switch (filterId) {
      case "role": {
        const roles = nextSelected.map((r) => (typeof r === "object" ? r.value ?? r.id : r));
        setRoleId(roles);
        break;
      }

      case "region": {
        const regions = nextSelected.map((r) => (typeof r === "object" ? r.value ?? r.id : r));
        setSelectedRegion(regions);
        setSelectedState([]);
        break;
      }
      case "state": {
        const states = nextSelected.map((s) => (typeof s === "object" ? s.value ?? s.id : s));
        setSelectedState(states);
        break;
      }
      case "year": {
        const selectedYears = nextSelected.map((y) => String(typeof y === "object" ? y.value : y));
        setSelectedYear(selectedYears);
        break;
      }
      default:
        break;
    }
  };


  const handleMonthChange = (event) => {
    const value = event.target.value;
    setSelectedMonth(typeof value === "string" ? value.split(",") : value);
  };

  const handleYearChange = (event) => {
    const value = event.target.value;
    setSelectedYear(typeof value === "string" ? value.split(",") : value);
  };

  const handleClearFilters = () => {
    setRoleId(state.role || []);
    setFromDate(state.from || null);
    setToDate(state.to || null);
    setSelectedMonth(Array.isArray(month) ? month : month ? [month] : FY_MONTH_ORDER);
    setSelectedYear(
      Array.isArray(state.year)
        ? state.year.map(String)
        : state.year
          ? [String(state.year)]
          : [String(new Date().getFullYear())]
    );
    setSearchTerm("");
    setSelectedRegion(state.region || null);
    setSelectedState([]);
  };



  useEffect(() => {
    dispatch(fetchRegion());
  }, []);

  return (
    <MainLayout title={"Quotation By User"}>
      <LoadingIndicator show={getStatus === "pending"} />

      <Box
        sx={{
          p: { xs: 1, md: 2 },
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
          minHeight: 800,
          mx: "auto",
          // backgroundColor: "#fff",
        }}
      >
        <FilterBar2
          filters={filterConfigs}
          onFilterChange={handleFilterChange}
          selectedMonth={selectedMonth}
          setSelectedMonth={setSelectedMonth}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          searchPlaceHolder="Search by Quotation ID, Client, Username..."
          selectedFromDate={fromDate}
          setSelectedFromDate={setFromDate}
          selectedToDate={toDate}
          setSelectedToDate={setToDate}
          onClearFilters={handleClearFilters}
          actions={
            <div className="flex items-center gap-2">
              <Tooltip title="Back to previous page">
                <IconButton
                  onClick={handleBackClick}
                  size="small"
                  sx={{
                    backgroundColor: "#fff",
                    border: "1px solid #cbd5e1",
                    "&:hover": { backgroundColor: "#f8fafc" },
                  }}
                >
                  <ArrowBackIosNew fontSize="small" />
                </IconButton>
              </Tooltip>

              <Button
                variant="contained"
                startIcon={<ExcelIcon />}
                onClick={downloadFile}
                sx={{
                  height: 32,
                  bgcolor: "#2e7d32",
                  textTransform: "none",
                  borderRadius: 12,
                  fontSize: "12px",
                  px: "14px",
                  "&:hover": { bgcolor: "#1b5e20" },
                }}
              >
                Excel
              </Button>
            </div>
          }
        />
        <Box>
          <Paper sx={{ width: "100%", borderRadius: 2, overflow: "hidden" }}>
            <TableContainer>
              <Table sx={{ minWidth: 750 }} aria-label="client table">
                <TableHead sx={{ background: "#04121f", color: "white" }}>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      SL No.
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Quotation ID
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Client
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Username
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Role
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Valid Upto
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Stage
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Created At
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Updated At
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userQuoteById?.length > 0 ? (
                    userQuoteById.map((client, index) => (
                      <TableRow
                        key={`${client.client_name}-${index}-${client.project_id}-${client.count}-${client.valid_date}`}
                        hover
                        sx={{
                          "&:nth-of-type(odd)": { backgroundColor: "#f9fafb" },
                          "&:hover": { backgroundColor: "#eef2ff" },
                          transition: "background-color 0.3s ease",
                        }}
                      >
                        <TableCell sx={{ fontWeight: "bold" }}>
                          {page * rowsPerPage + index + 1}
                        </TableCell>
                        <TableCell sx={{}}>{client.project_id}</TableCell>
                        <TableCell sx={{}}>{client.client_name}</TableCell>
                        <TableCell sx={{}}>{client.username}</TableCell>
                        <TableCell sx={{}}>
                          {client.role == 2
                            ? "IC"
                            : client.role == 3
                              ? "BSP"
                              : client.role == 4
                                ? "DSP"
                                : client.role == 5
                                  ? "BD"
                                  : client.role == 6
                                    ? "Sales Enabler"
                                    : client.role == 7
                                      ? "Dealer"
                                      : client.role == 8
                                        ? "Studio"
                                        : client.role}
                        </TableCell>
                        <TableCell sx={{}}>
                          {new Date(client.valid_date).toLocaleDateString(
                            "en-GB"
                          )}
                        </TableCell>
                        <TableCell sx={{}}>{client.status}</TableCell>
                        <TableCell sx={{}}>
                          {new Date(client.created_at).toLocaleString("en-GB")}
                        </TableCell>
                        <TableCell sx={{}}>
                          {new Date(client.updated_at).toLocaleString("en-GB")}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        <Typography
                          variant="subtitle1"
                          color="text.secondary"
                          sx={{ py: 2 }}
                        >
                          No data available
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, totalCount || 0]}
              component="div"
              count={totalCount || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Box>
      </Box>
    </MainLayout>
  );
};

export default QuoteByUserId;
